import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import { dateFormat } from '@/Utils/fliter'

function getYM (data, vm) {
  let dateData = ''
  if (data.monthname !== '') {
    const dateDataM = { text: vm.$t('production_store.month') + ' : ' + data.monthname, style: 'td', alignment: 'right' }
    dateData = dateDataM
  }
  return dateData
}

const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, data, vm, titleData) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      pdfContent.push(
        {
          table: {
            style: 'tableData',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadData.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadData.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: reportHeadData.orgName, style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.heading, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadData.address, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportTitle, style: 'address2', alignment: 'center' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )
        pdfContent.push(
          {
            table: {
              style: 'tableData',
              headerRows: 0,
              widths: ['33%', '33%', '33%'],
              body: [
                [
                  { },
                  { },
                  { }
                ],
                [
                  { },
                  { text: '', style: 'td', alignment: 'center' },
                  { text: titleData.year, style: 'td', alignment: 'right' }
                ],
                [
                  { text: titleData.demand_type, style: 'td', alignment: 'left' },
                  { },
                  getYM(titleData, vm)
                ]
              ]
            },
            layout: {
              hLineWidth: function (i, node) {
                return 0
              },
              vLineWidth: function (i, node) {
                return 0
              }
            }
          }
        )
        // pdfContent.push({ text: '', style: 'fertilizer', alignment: 'center' })
        const allRowsHead = [
            [
              { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
              { text: vm.$t('globalTrans.date'), style: 'th', alignment: 'center' },
              { text: vm.$t('globalTrans.description'), style: 'th', alignment: 'center' },
              { text: vm.$t('sales_distribution_admin.bill_no'), style: 'th', alignment: 'center' },
              { text: vm.$t('assitive_device_management.challan_no'), style: 'th', alignment: 'center' },
              { text: vm.$t('sales_distribution_admin.amount_number'), style: 'th', alignment: 'center' },
              { text: vm.$t('sales_distribution_admin.collect_date'), style: 'th', alignment: 'center' },
              { text: vm.$t('production_store.comment'), style: 'th', alignment: 'center' }
            ]
        ]
        data.map((report, index) => {
          let name = ''
          if (report.sales_center_id) {
            name = vm.getSalesCenterName(report.sales_center_id)
          } else if (report.delivery_main?.del_or_retail_sc_id) {
            name = vm.getDealerRetailerName(report.delivery_main?.del_or_retail_sc_id)
          } else {
            name = i18n.locale === 'bn' ? report.delivery_main?.name_bn : report.delivery_main?.name
          }

          allRowsHead.push(
          [
            { text: vm.$n(index + 1), style: 'td', alignment: 'center' },
            { text: dateFormat(report.receive_date), style: 'td', alignment: 'center' },
            { text: name, style: 'td', alignment: 'center' },
            { text: 'Bill-' + report.delivery_order_id, style: 'td', alignment: 'center' },
            { text: 'CH-' + report.delivery_order_id, style: 'td', alignment: 'center' },
            { text: vm.$n(report.total_amount), style: 'td', alignment: 'center' },
            { text: vm.getDates(report.payments), style: 'td', alignment: 'center' },
            { text: '', style: 'td', alignment: 'center' }
          ])
        })
        allRowsHead.push(
          [
            { text: vm.$t('globalTrans.total'), style: 'td', colSpan: 5, alignment: 'right' },
            {},
            {},
            {},
            {},
            { text: vm.$n(vm.totalAmountSum()), style: 'td', alignment: 'center' },
            {},
            {}
          ])
        pdfContent.push({
          table: {
            headerRows: 0,
            margin: 0,
            style: 'tableData',
            widths: ['5%', '*', '*', '*', '*', '*', '*', '*', '5%'],
            body: allRowsHead
          }
        })
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজকল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
          content: pdfContent,
          pageSize: 'A4',
          pageOrientation: 'landscape',
          watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
          styles: {
            th: {
              fillColor: '#dee2e6',
              fontSize: 8,
              margin: [3, 3, 3, 3]
            },
            th1: {
              fontSize: 9
            },
            td: {
              fontSize: 8,
              margin: [3, 3, 3, 3]
            },
            header: {
              margin: [0, 1, 0, 15],
              fontSize: 16,
              alignment: 'center'
            },
            header2: {
              border: 0,
              fontSize: 14,
              margin: [0, 0, 0, 1]
            },
            govt_info: {
              margin: [0, 1, 0, 1],
              fontSize: 18,
              alignment: 'center'
            },
            address2: {
              border: 0,
              fontSize: 12,
              bold: true,
              margin: [0, 0, 0, 5]
            },
            left_logo: {
              border: 0,
              margin: [5, 0, 0, 5]
            }
          }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
